import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

import getMatch from './getMatch';
import hasFetchedActiveContent from './hasFetchedActiveContent';

export const getIsRoute404 = createSelector(
  [getMatch],
  (match) => !match || !match.url,
);

const getIsContent404 = createSelector(
  [
    hasFetchedActiveContent,
    get('active.loading.content'),
    get('active.loading.more'),
  ],
  (hasFetched, isLoading, isLoadingMore) => !(isLoading || isLoadingMore) && !hasFetched,
);

const getIs404 = createSelector(
  [
    getIsContent404,
    getIsRoute404,
  ],
  (content404, route404) => content404 || route404,
);

export default getIs404;
